import { atomWithReset } from 'jotai/utils';

import type { NotificationWizardState } from '../../types/notification';

const INITIAL_STATE: NotificationWizardState = {
  step: 0,
  audience: {
    classroomIds: [],
    enrollmentStatuses: [],
    classroomStudentCounts: {},
    classroomNames: {},
  },
  message: {
    title: '',
    body: '',
    url: '',
  },
  schedule: {
    mode: 'now',
    scheduledAt: null,
  },
  notificationType: 1,
};

/**
 * Atom do wizard de envio de notificação.
 * Armazena o step atual e os dados acumulados de cada etapa.
 * Use `useNotificationWizard` para acessar e manipular este atom.
 */
export const notificationWizardAtom = atomWithReset<NotificationWizardState>(INITIAL_STATE);
